<template>
  <div :class="sytleType == 'vip' ? 'vipType' : ''" class="header">
    <p @click="onClickLeft" class="label">
      <van-icon name="arrow-left" class="goBack" />
    </p>

    <h5 class="title">{{ title }}</h5>
    <div class="label-right">
      <slot name="headRight"></slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineEmits, defineProps } from 'vue';
import { useRouter } from 'vue-router';
import { useHot } from '@star/stores';

const { hotData } = useHot();
const { userInfo } = hotData;
const props = defineProps({
  title: {
    type: String,
    detail: '标题',
  },
  type: {
    type: String,
    detail: 'view',
  },
  sytleType: {
    type: String,
    detail: '',
  },
});
const emit = defineEmits(['goBack']);
const router = useRouter();
const onClickLeft = () => {
  if (props.type == 'popup') {
    emit('goBack');
  } else if (props.type == 'agent') {
    if (userInfo.value.isFlutter) {
      window.FlutterJSChannel.postMessage(JSON.stringify({ type: 'backToFlutter' }));
    } else {
      router.push('/mine');
    }
  } else {
    router.go(-1);
  }
};
</script>

<style lang="less" scoped>
:deep(i) {
  font-size: 60px !important;
  color: #000 !important;
}

.header {
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  line-height: var(--header-height);
  padding: 0 20px;
  height: var(--header-height);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2000;
  border-bottom: 1px solid rgb(240, 240, 240);

  .goBack {
    width: 120px;
    height: 120px;
    display: block;
    padding-top: 30px;
  }

  .title {
    text-align: center;
    flex: 2;
  }

  .label {
    flex: 1;
  }

  .label-right {
    text-align: right;
    margin-right: 20px;
    flex: 1;

    color: rgb(133, 133, 133);
  }
}

.vipType {
  background: #2c3349;
  color: #fff;
  border-bottom: 1px solid #2c3349;

  i {
    color: #fff !important;
  }

  .title {
    color: #fff;
  }
}

.van-nav-bar--fixed {
  z-index: 9;
}

:deep(.van-nav-bar__content) {
  background: #fff;
  border-bottom: 1px solid rgb(214, 214, 214);
}
</style>
